// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from NamedDaysAddon.module.scss  */
.NamedDaysAddon-module-Root_1od {
  display: flex;
  justify-content: space-between;
  width: 100%; }

.NamedDaysAddon-module-DayNavigationButton_2cW {
  overflow: visible;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-align: center;
  color: var(--calendar-button-today);
  border: none;
  background: transparent; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Calendar/View/NamedDaysAddon/NamedDaysAddon.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW,EAAE;;AAEf;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,uBAAuB,EAAE","sourcesContent":["/*  imported from NamedDaysAddon.module.scss  */\n.NamedDaysAddon-module-Root_1od {\n  display: flex;\n  justify-content: space-between;\n  width: 100%; }\n\n.NamedDaysAddon-module-DayNavigationButton_2cW {\n  overflow: visible;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  text-align: center;\n  color: var(--calendar-button-today);\n  border: none;\n  background: transparent; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
